import queryString from 'query-string';

import store from 'store';
import { addJob } from 'store/views/global/rivals';

import { api } from '../api';

import type {
  CreateRivalQueryType,
  CreateRivalReturnType,
  FetchRivalsQueryType,
  FetchRivalsReturnType,
} from 'api/endpoints/rivals.types';

export type DeleteRivalRequest = {
  rivalId: number;
  profileId: number;
};

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    createRival: build.mutation<
      CreateRivalReturnType,
      CreateRivalQueryType & { silent?: boolean }
    >({
      query: ({ silent: _silent, ...params }) => ({
        url: 'rivals.json',
        method: 'POST',
        body: params,
      }),
      onQueryStarted: async (params, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          addJob({
            id: data.statusId,
            rivalId: data.id,
            silent: params.silent,
          });
          store.dispatch.rivals.populate({
            rivals: {
              [data.id]: {
                ...data,
                profile: data.profile.id,
                profileId: data.profile.id,
              },
            },
          });
          // TODO Rival Groups...
        } catch {
          // Do nothing
        }
      },
      invalidatesTags: ['Rivals'],
    }),
    getRivals: build.query<FetchRivalsReturnType, FetchRivalsQueryType>({
      query: (params) => {
        const parsedParams = { ...params };

        if (parsedParams.minimal === false) {
          delete parsedParams.minimal;
        }

        return `rivals.json?${queryString.stringify(
          { ...parsedParams },
          {
            arrayFormat: 'bracket',
          },
        )}`;
      },
      providesTags: ['Rivals'],
    }),
    deleteRival: build.mutation<void, DeleteRivalRequest>({
      query: ({ rivalId }) => ({
        url: `rivals/${rivalId}`,
        method: 'DELETE',
      }),
      onQueryStarted: async ({ rivalId, profileId }, { queryFulfilled }) => {
        try {
          await queryFulfilled;
          store.dispatch.rivals.deleteRivalById({ id: rivalId.toString() });
          store.dispatch.profiles.deleteProfileById({
            id: profileId.toString(),
          });
        } catch (error) {
          // Do nothing
        }
      },
      invalidatesTags: ['Rivals'],
    }),
  }),
});

export const {
  useCreateRivalMutation,
  useGetRivalsQuery,
  useDeleteRivalMutation,
} = extendedApi;
